import { AirHelpPlusBenefitsSection } from "modules/sections/AirHelpPlusBenefitsSection";
import type { AirHelpPlusBenefitsSectionProps } from "modules/sections/AirHelpPlusBenefitsSection";
import type { ReactStoryblokComponent } from "types/storyblok";

export const AirHelpPlusBenefitsSectionAdapter = ({
  blok: { heading, imageUrlDesktop, imageUrlMobile, imageUrlTablet, imageAlt, benefits, button },
  sbEditable,
}: ReactStoryblokComponent<AirHelpPlusBenefitsSectionProps>) => (
  <AirHelpPlusBenefitsSection
    heading={heading}
    imageUrlDesktop={imageUrlDesktop}
    imageUrlMobile={imageUrlMobile}
    imageUrlTablet={imageUrlTablet}
    imageAlt={imageAlt}
    benefits={benefits}
    button={button}
    sbEditable={sbEditable}
  />
);
